/**
 * UcStickers — блок «Наклейки (N)» UC-панели (screen-22, эталон renderSt
 * js:188-194): «кто → кому» первыми словами (EO-вид НЕанонимный — УД7,
 * сервер отдаёт sender_name открыто в /api/uc/log), emoji как данные,
 * сообщение и ответ в «кавычках», срок жизни справа (короткий — orange,
 * длинный/истёкший — приглушён .long). Лента — последние N из /api/uc/log.
 */
import type { MouseEvent } from "react";
import type { UcAdmin } from "../../hooks/useUcAdmin";
import { firstWord, stickerExp } from "./ucFmt";
import cfg from "./config.module.css";
import pcss from "./prices.module.css";
import qcss from "./quests.module.css";
import ucss from "./uc.module.css";

/** Чат-пузырь шапки (эталон html:229). */
const StIco = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16v12H9l-5 5z" />
    <path d="M8 9h8M8 12h5" />
  </svg>
);

export function UcStickers({ uc, onTip }: {
  uc: UcAdmin;
  onTip: (e: MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <div className={ucss.blk}>
      <div className={`${qcss.s17head} ${ucss.hd}`}>
        <span className={ucss.hpk}><StIco /></span>
        <h2 className={cfg.secT}>Наклейки ({uc.stickers.length})</h2>
        <button type="button" className={pcss.qmark} data-qmark="" aria-label="Справка" onClick={onTip}>
          <span>?</span>
        </button>
      </div>
      {uc.stickers.length ? (
        <div className={ucss.mcard}>
          {uc.stickers.map((s) => {
            const exp = stickerExp(s);
            return (
              <div key={s.id} className={ucss.srow}>
                <div className={ucss.l1}>
                  <span className={ucss.who}>
                    {firstWord(s.sender_name)}
                    <span className={ucss.arr}>→</span>
                    {firstWord(s.target_name)}
                  </span>
                  {s.sticker_emoji ? <span className={ucss.emo}>{s.sticker_emoji}</span> : null}
                  <span className={`${ucss.exp} ${qcss.num} ${exp.long ? ucss.long : ""}`}>{exp.text}</span>
                </div>
                {s.message ? <div className={ucss.msg}>«{s.message}»</div> : null}
                {s.reply_text ? (
                  <div className={ucss.rep}><span className={ucss.ra}>↩</span> «{s.reply_text}»</div>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : (
        <div className={cfg.teaEmpty}>Нет наклеек</div>
      )}
    </div>
  );
}
